import React from 'react';

interface CustomButtonInterface {
	handleOnClick: (e: React.MouseEvent<HTMLElement>) => void;
	btnText: string;
	buttonClass?: string; // Required prop, no default value needed
	topViewClass?: string; // Optional prop if needed
}

// Function declaration instead of arrow function
export function CustomButton({
	handleOnClick,
	btnText,
	buttonClass,
	topViewClass,
}: CustomButtonInterface): JSX.Element {
	return (
		<div className={`flex ${topViewClass}`}>
			<button type="button" onClick={handleOnClick} className={buttonClass}>
				{btnText}
			</button>
		</div>
	);
}
